import { BaseModel } from "./base";
import { Veiculo } from "./veiculo";

export default class Cor extends BaseModel {
  constructor(
    public id: number,
    public nome: string,
    public createdAt: Date,
    public updatedAt: Date,
    public codigoGetran: String,
    public veiculos: Veiculo[]
  ) {
    super(id);
  }
}
